export default __webpack_public_path__ + "static/media/010_photo.1efa53b6.jpg";